import { put, call, takeEvery } from 'typed-redux-saga';

import SettingGateway from '~apis/setting';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetPendingProductListing(api: SettingGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalGetPendingProductListingAttempt', handleGetPendingProductListing, api);
}

function* handleGetPendingProductListing(api: SettingGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        index,
        filters: {
            productName,
            metalType,
        },
    } = reduxState.approval.pendingProductListing;

    if (!index && index !== 0) {
        yield put(combinedActions.approvalGetPendingProductListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getProductChangeHistoryListing], {
        authToken,
        index,
        productName: productName || undefined,
        metalType,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalGetPendingProductListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.approvalGetPendingProductListingSuccess(response.data));
    }
}
